module.exports = __webpack_public_path__ + "01_medium_gold.252619b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_medium_gold.png
// module id = uTAl
// module chunks = 0